<template>
  <div>
    <Button
      type="primary"
      class="mb-3"
      :to="{ name: 'operator-group-add' }"
      v-if="getpermission.opergroup[1] == '1'"
    >新增</Button>
    <Row type="flex" align="middle">
      <table class="TB_COLLAPSE" width="100%">
        <thead>
          <th width="20%">序号</th>
          <th width="20%">分组名称</th>
          <th width="20%">更新时间</th>
          <th width="20%" v-if="getpermission.opergroup[2] == '1'">修改</th>
          <th width="20%" v-if="getpermission.opergroup[3] == '1'">删除</th>
        </thead>
        <tbody>
          <tr v-for="(it, index) in datatb" :key="index+'index'">
            <td>{{it.id}}</td>
            <td>{{it.name}}</td>
            <td>{{it.updatetime}}</td>
            <td v-if="getpermission.opergroup[2] == '1'">
              <Button type="warning" :to="{name: 'operator-group-modify', params: { id: it.id }}">修改</Button>
            </td>
            <td v-if="getpermission.opergroup[3] == '1'">
              <Button type="error" @click="opersaene(it.id)">删除</Button>
            </td>
          </tr>
        </tbody>
      </table>
    </Row>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: 'list',
  data () {
    return {
      datatb: []
    };
  },
  computed: {
    ...mapGetters(['getpermission']),
  },
  created () {
    this.operlt();
  },
  methods: {
    async operlt () {
      try {
        const res = await this.$axios.operatorGroup.getOperatorGroupList()
        if ('status' in res && res.status === 0) return
        this.datatb = res;
      } catch (error) {
        console.error(error)
      }
    },
    opersaene (oid) {
      this.$Modal.confirm({
        title: "提示信息",
        content: "确认是否要删除操作员组 ?",
        onOk: res => {
          this.$axios.operatorGroup
            .remove({ oid })
            .then(res => {
              if (res.status == '1') {
                this.$Message.success('已更改');
                this.operlt();
              } else {
                this.operlt();
              }
            });
        }
      });
    }
  }
};
</script>
